import CopyUrlIcon from './CopyUrlIcon';
import EditIcon from './EditIcon';
import SortAscending from './SortAscending';
import SortDescending from './SortDescending';

export default {
  EditIcon,
  CopyUrlIcon,
  SortAscending,
  SortDescending,
};
